/** Service hospitalier avec file d'attente propre. */
export type ServiceQueueId =
  | "admission"
  | "clinical"
  | "nursing"
  | "pharmacy"
  | "laboratory"
  | "imaging";

export type QueueTicketStatus =
  | "waiting"
  | "called"
  | "in_progress"
  | "completed"
  | "cancelled";

export interface QueueTicket {
  id: string;
  patientId: string;
  admissionId: string | null;
  billingDocumentId: string | null;
  serviceId: ServiceQueueId;
  /** Unité / spécialité (ex. Médecine générale). */
  unitName: string;
  /** Box ou salle du praticien. */
  boxLabel: string | null;
  assignedPractitionerId: string | null;
  assignedPractitionerName: string | null;
  status: QueueTicketStatus;
  motif: string;
  priority: number;
  consultationId: string | null;
  createdAt: string;
  updatedAt: string;
  calledAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
}

export interface EnqueueTicketInput {
  patientId: string;
  admissionId?: string | null;
  billingDocumentId?: string | null;
  serviceId: ServiceQueueId;
  unitName: string;
  motif: string;
  priority?: number;
}

export const QUEUE_STATUS_LABELS: Record<QueueTicketStatus, string> = {
  waiting: "En salle d'attente",
  called: "Appelé",
  in_progress: "En consultation",
  completed: "Terminé",
  cancelled: "Annulé",
};

export const SERVICE_QUEUE_LABELS: Record<ServiceQueueId, string> = {
  admission: "Accueil",
  clinical: "Clinique",
  nursing: "Soins infirmiers",
  pharmacy: "Pharmacie",
  laboratory: "Laboratoire",
  imaging: "Imagerie",
};

/** Mappe une destination d'orientation vers un service + libellé unité. */
export function resolveServiceFromDestination(destination: string): {
  serviceId: ServiceQueueId;
  unitName: string;
} {
  const d = destination.trim().toLowerCase();
  if (d.includes("pharmac")) return { serviceId: "pharmacy", unitName: "Pharmacie" };
  if (d.includes("labo")) return { serviceId: "laboratory", unitName: "Laboratoire" };
  if (d.includes("imag") || d.includes("radio")) {
    return { serviceId: "imaging", unitName: "Imagerie" };
  }
  if (d.includes("soins infirm") || d.includes("constantes")) {
    return { serviceId: "nursing", unitName: "Prise des constantes" };
  }
  if (d.includes("résultat") || d.includes("resultat")) {
    return { serviceId: "clinical", unitName: "Consultation résultats" };
  }
  if (d.includes("hospital")) {
    return { serviceId: "nursing", unitName: destination.trim() };
  }
  if (d.includes("urgence")) return { serviceId: "clinical", unitName: "Urgences" };
  return { serviceId: "clinical", unitName: destination.trim() };
}
